import type { Track } from "@similarweb/tracking-provider";

import type { FilterModeType } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";

import { FILTER_MODE_TO_EVENT_NAME } from "./const";
import type { SearchPanelContext } from "./const";

export function createAdvancedSearchFilteringTrackingService(track: Track) {
    return {
        trackSearchFieldUsed(searchEntity: string, text: string) {
            track("table", "search", createTrackingEventName(`${searchEntity} results`, "quick search", text));
        },
        trackSearchFieldCleared(searchEntity: string, text: string) {
            track("table", "cancel", createTrackingEventName(`${searchEntity} results`, "quick search", text));
        },

        trackIsNewOnlyChanged(isEnabled: boolean) {
            if (isEnabled) {
                track("table", "only new", "new matches");
            } else {
                track("table", "cancel", "new matches");
            }
        },

        filtersPanel: {
            trackChangeFilteringMode(filterMode: FilterModeType) {
                track("filters panel", "use toggle", FILTER_MODE_TO_EVENT_NAME[filterMode]);
            },

            trackSearchInputFocused() {
                track("filters panel", "click", createTrackingEventName("search input focused"));
            },
            trackSearchType(charCount: number, filterCount: number, panelContext: SearchPanelContext) {
                track("filters panel", "search", createTrackingEventName(charCount, filterCount, panelContext));
            },
            trackSearchClear() {
                track("filters panel", "search", createTrackingEventName("clear"));
            },

            trackFilterPanelExpand() {
                track("filters panel", "expand", createTrackingEventName("filters panel expanded"));
            },
            trackFilterPanelCollapsed() {
                track("filters panel", "collapse", createTrackingEventName("filters panel collapsed"));
            },

            trackFilterExpand(filterName: string, tabName: string | null, searchTerm: string) {
                track(
                    "filters panel",
                    "expand",
                    createTrackingEventName("expand filter", filterName, tabName ?? "", searchTerm || undefined),
                );
            },
            trackFilterCollapse(filterName: string, tabName: string | null) {
                track(
                    "filters panel",
                    "collapse",
                    createTrackingEventName("collapse filter", filterName, tabName ?? ""),
                );
            },

            trackShowMoreFilters() {
                track("filters panel", "click", createTrackingEventName("more filters"));
            },
            trackShowLessFilters() {
                track("filters panel", "click", createTrackingEventName("less filters"));
            },

            trackChangeFiltersTab(filterTabName: string) {
                track("filters panel", "click", createTrackingEventName("filters tab", filterTabName));
            },

            trackCategoryViewMore(categoryName: string) {
                track("filters panel", "click", createTrackingEventName("category view more", categoryName));
            },

            trackPinFilter(filterName: string, isPinned: boolean) {
                track("filters panel", "click", createTrackingEventName("pin filter", filterName, String(isPinned)));
            },
        },
    };
}
